import React from 'react'
import { Box } from 'reflexbox'

export default props => <Box as="h2" mt={['30px', '20px']} mb={['37px', '30px']} {...props} />
